(function (app) {

    app.provider("marketingPlanApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getMarketingPlanSummaries = function (agentId) {
                            return marketingTrackerApiGateway.getArray("/Agents/" + agentId + "/MarketingPlans/Summary");
                        }

                        service.getSeminarPlanSummaries = function (agentId) {
                            return marketingTrackerApiGateway.getArray("/Agents/" + agentId + "/SeminarPlans");
                        }

                        service.getCollegePlanSummaries = function (agentId) {
                            return marketingTrackerApiGateway.getArray("/Agents/" + agentId + "/CollegePlans");
                        }

                        service.getMarketingPlanDocument = function (agentId, marketingPlanId) {
                            return marketingTrackerApiGateway
                                .getFile("/Agents/" + agentId + "/MarketingPlans/" + marketingPlanId + "/Document");
                        }

                        service.getSeminarPlanDocument = function (agentId, seminarPlanId) {
                            return marketingTrackerApiGateway
                                .getFile("/Agents/" + agentId + "/SeminarPlans/" + seminarPlanId + "/Document");
                        }

                        service.getCollegePlanDocument = function (agentId, collegePlanId) {
                            return marketingTrackerApiGateway
                                .getFile("/Agents/" + agentId + "/CollegePlans/" + collegePlanId + "/Document");
                        }

                        service.getMarketingPlanByYear = function (agentId, year) {
                            return marketingTrackerApiGateway.get("/Agents/" + agentId + "/MarketingPlans/Year/" + year);
                        }

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line